// flow
import * as React from 'react';
import classNames from 'classnames';
import { getFormattedMessageTag } from 'utils/string';

// components
import ErrorModal from '../../containers/ErrorModal/ErrorModal';

import './FatalError.scss';
import ParseHTML from 'components/atoms/ParseHTML';

class FatalError extends React.Component<Props> {
  static block = 'fatal-error';

  constructor(props: Props, context: any) {
    super(props, context);
    (this: any).modal = React.createRef();
  }

  setShowModal = (show: boolean = true) => {
    (this: any).modal.current.setShowModal(show);
  };

  render() {
    const ns = FatalError.block;
    const { noAdvisorsError, intl } = this.props;

    const inputClassNames = classNames({
      [`${ns}__traffic-light my-4`]: noAdvisorsError,
      [`${ns}__stop-icon mt-4`]: !noAdvisorsError
    });

    return (
      <ErrorModal
        ref={this.modal}
        icon={() => <div className={inputClassNames} />}
        content={() => {
          return (
            <div>
              <div className={`${ns}__title mt-4`}>
                {!noAdvisorsError &&
                  getFormattedMessageTag('c8.error.oops', '')}
                {noAdvisorsError &&
                  getFormattedMessageTag('c8.error.no.capacity', 'No capacity')}
              </div>
              <div className={`${ns}__message my-5`}>
                {!noAdvisorsError && (
                  <ParseHTML
                    html={intl.formatMessage({
                      id:
                        'c8.error.something.did.not.go.as.planned.please.try.again',
                      defaultMessage: ''
                    })}
                  />
                )}
                {noAdvisorsError &&
                  getFormattedMessageTag(
                    'c8.error.no.capacity.message',
                    'There is no capacity for the services selected. Please change your service selection.'
                  )}
              </div>
            </div>
          );
        }}
      />
    );
  }
}

export default FatalError;



// WEBPACK FOOTER //
// ./src/components/api/components/FatalError/FatalError.js